function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n0% {\n  opacity: 1;\n}\n50% {\n  opacity: 0.5;\n}\n100% {\n  opacity: 1;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n60%, 100% {\n  transform: translateX(100%) skewX(173deg);\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { useMemo } from "react";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { keyframes } from "@emotion/react";
import { BORDER_RADIUS } from "./Skeleton";
var pulse = keyframes(_templateObject());
var shimmer = keyframes(_templateObject1());
var buildStyle = function(theme, param) {
    var readingDirection = param.readingDirection;
    var animation = theme.animation, backgroundColor = theme.backgroundColor, size = theme.size;
    return {
        skeleton: {
            base: {
                display: 'inline-block',
                backgroundColor: backgroundColor.neutral.disabled,
                overflow: 'hidden',
                position: 'relative',
                borderRadius: 0,
                height: '1rem',
                width: '100%'
            },
            isFilled: {
                backgroundColor: backgroundColor.neutral.fill.disabled
            },
            hasAnimation: _objectSpread({}, (readingDirection === null || readingDirection === void 0 ? void 0 : readingDirection.direction) === 'rtl' && {
                animationDirection: 'reverse'
            }, {
                animationDelay: animation.duration[100],
                animationDuration: '2000ms',
                animationIterationCount: 'infinite',
                animationTimingFunction: animation.expressive.easeInOut.easing
            }),
            hasPulse: {
                animationName: "".concat(pulse)
            },
            hasShimmer: {
                background: "linear-gradient(83deg, ".concat(backgroundColor.neutral.disabled, " 0%, ").concat(backgroundColor.neutral.fill.disabled, " 40%, ").concat(backgroundColor.neutral.fill.disabled, " 60%, ").concat(backgroundColor.neutral.disabled, " 100%)"),
                animationName: "".concat(shimmer),
                transform: 'translateX(-100%) skewX(173deg)',
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            },
            isFilledAndHasShimmer: {
                background: "linear-gradient(83deg, ".concat(backgroundColor.neutral.fill.disabled, " 0%, ").concat(backgroundColor.neutral.disabled, " 40%, ").concat(backgroundColor.neutral.disabled, " 60%, ").concat(backgroundColor.neutral.fill.disabled, " 100%)")
            },
            hasChildren: {
                padding: '1rem',
                height: 'inherit'
            },
            borderRadius: {
                none: size.border.radius.none,
                twoX: size.border.radius.twoX,
                threeX: size.border.radius.threeX,
                fiveX: size.border.radius.fiveX,
                round: size.border.radius.round
            }
        }
    };
};
export var useStyle = function(param) {
    var borderRadius = param.borderRadius, hasChildren = param.hasChildren, hasPulse = param.hasPulse, hasShimmer = param.hasShimmer, height = param.height, isFilled = param.isFilled, isRtl = param.isRtl, width = param.width;
    var ref1;
    var skeleton = ((ref1 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref1 !== void 0 ? ref1 : {}).skeleton;
    return useMemo(function() {
        var ref;
        var after = _objectSpread({}, skeleton === null || skeleton === void 0 ? void 0 : skeleton.hasAnimation, hasShimmer && (skeleton === null || skeleton === void 0 ? void 0 : skeleton.hasShimmer), hasPulse && !hasShimmer && (skeleton === null || skeleton === void 0 ? void 0 : skeleton.hasPulse), isFilled && hasShimmer && (skeleton === null || skeleton === void 0 ? void 0 : skeleton.isFilledAndHasShimmer));
        return {
            skeleton: _objectSpread({}, skeleton === null || skeleton === void 0 ? void 0 : skeleton.base, hasChildren && (skeleton === null || skeleton === void 0 ? void 0 : skeleton.hasChildren), height && {
                height: height
            }, width && {
                width: width
            }, isFilled && (skeleton === null || skeleton === void 0 ? void 0 : skeleton.isFilled), hasPulse && !hasShimmer && !hasChildren && after, hasShimmer && !hasChildren && {
                '&::after': after
            }, borderRadius && typeof borderRadius === 'string' && BORDER_RADIUS.includes(borderRadius) ? {
                borderRadius: skeleton === null || skeleton === void 0 ? void 0 : (ref = skeleton.borderRadius) === null || ref === void 0 ? void 0 : ref[borderRadius]
            } : {
                borderRadius: borderRadius
            })
        };
    }, [
        skeleton,
        height,
        width,
        borderRadius,
        hasShimmer,
        isFilled,
        hasChildren,
        hasPulse
    ]);
};
export default useStyle;
